import { Typography } from '@mui/material'

import useDirectory from './useDirectory'
import styles from './Directory.module.scss'
import { Copy, CopyContainer } from '../../../../../common/copy'
import { Loading } from '../../../../../common'

const Directory = () => {
  const { contacts, loading, error } = useDirectory()

  if (loading) return <Loading loading={true} message="Opening phone book…" />
  if (error) return <div>Error: {error}</div>

  return (
    <div className={styles.directoryRoot}>
      <CopyContainer padding={{ top: '0', left: 'xsmall', right: 'xsmall' }}>
        <Copy stackSpacing="medium">
          <Typography variant="h2">Directory</Typography>
        </Copy>
        <CopyContainer
          padding={{ top: 'small', left: 'xsmall', right: 'xsmall' }}
        >
          <Copy>
            <ul>
              {contacts.map((contact, key) => (
                <li key={key}>
                  <div>
                    <Typography>
                      {contact?.name && contact.name}
                      {contact?.business && (
                        <strong style={{ fontWeight: 800 }}>
                          {contact.business}
                        </strong>
                      )}
                      {!contact?.name && !contact?.business ? '?: ' : ': '}
                      {contact.exchangeNumber}
                    </Typography>
                  </div>
                  <br />
                </li>
              ))}
            </ul>
          </Copy>
        </CopyContainer>
      </CopyContainer>
    </div>
  )
}

export default Directory
